export default {"src":"/_next/static/media/dropdown-icon.6858e903.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};